module.exports = __webpack_public_path__ + "bitgive.png?0f4521d9d47843dc665bbe06fb9047e3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/charity/bitgive.png
// module id = 1068
// module chunks = 2